import React from "react";
import { Badge } from "../../../components/ui/badge";

interface RepositoriesPageHeaderProps {
  totalCount: number;
  visibleCount: number;
  favoritesCount: number;
}

const RepositoriesPageHeader = ({
  totalCount,
  visibleCount,
  favoritesCount,
}: RepositoriesPageHeaderProps) => {
  return (
    <div className="space-y-3">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Repositories</h1>
        <p className="text-sm text-muted-foreground">
          Manage accessible repositories, favorites, and open localization editor quickly.
        </p>
      </div>
      <div className="flex flex-wrap gap-2">
        <Badge variant="outline">Total: {totalCount}</Badge>
        <Badge variant="outline">Favorites: {favoritesCount}</Badge>
        <Badge variant="outline">Visible: {visibleCount}</Badge>
      </div>
    </div>
  );
};

export default RepositoriesPageHeader;
